import { tap } from "./fable_modules/Fable.Promise.3.2.0/Promise.fs.js";
import { errorToast } from "./Toasts.jsx";
import { startAsPromise } from "./fable_modules/fable-library-js.4.29.0/Async.js";
import { User, toastServerError, Notification } from "./ApiClient.jsx";
import { ThemeType, useCtx, ContextMsg } from "./Context.jsx";
import { createElement } from "react";
import React from "react";
import { ScreenSize, useFeliz_React__React_useResponsive_Static_Z434A9929 } from "./fable_modules/Feliz.UseMediaQuery.1.5.0/UseMediaQuery.fs.js";
import { useEffectOnce } from "./fable_modules/Feliz.2.9.0/Internal.fs.js";
import { int32ToString, createObj, equals } from "./fable_modules/fable-library-js.4.29.0/Util.js";
import { Role__ToDescription, Role_AllowedViewAs_335EB78D, Role, UserState } from "./Shared/SharedModels.jsx";
import { take, length as length_1, map, empty, singleton, append, delay, toList } from "./fable_modules/fable-library-js.4.29.0/Seq.js";
import { Divider, MenuList, MenuItem, Link, MenuDivider, tokens, Caption1, Body1Strong, MenuPopover, Subtitle2, Persona, MenuTrigger, Menu, Button, Hamburger } from "@fluentui/react-components";
import { reactApi } from "./fable_modules/Feliz.2.9.0/Interop.fs.js";
import { length, ofArray } from "./fable_modules/fable-library-js.4.29.0/List.js";
import { SignOutRegular, CheckmarkRegular, PersonSettingsRegular, BookClockRegular, LayerDiagonalPersonRegular, PersonRegular, DarkThemeRegular } from "@fluentui/react-icons";
import { NotificationMenu } from "./Notification.jsx";
import { abbreviateName } from "./Helpers.jsx";
import { defaultArg } from "./fable_modules/fable-library-js.4.29.0/Option.js";
import { reactApi as reactApi_1 } from "./fable_modules/Feliz.2.9.0/Interop.fs.js";
import { RouterModule_encodeParts } from "./fable_modules/Feliz.Router.4.0.0/Router.fs.js";

function fetchInitialNotifications(callback, setCtx) {
    const pr = tap((res) => {
        if (res.tag === 1) {
            errorToast(setCtx, "fetchNotificationError", "Kunne ikke hente kunngjøringer", "", undefined);
        }
        else {
            callback(res.fields[0]);
        }
    }, startAsPromise(Notification.GetMy(0)));
    void (pr.catch((ex) => {
        toastServerError(setCtx, ex);
    }));
}

function switchActiveRole(requested, setCtx) {
    let pr_1;
    const pr = startAsPromise(User.SetActiveRole(requested));
    pr_1 = (pr.then((res) => {
        if (res.tag === 1) {
            if (res.fields[0].tag === 1) {
                errorToast(setCtx, "switchActiveRoleInternal", "Kan ikke bytte rolle", "", undefined);
            }
            else {
                errorToast(setCtx, "switchActiveRoleNotAllowed", "Kan ikke bytte rolle", "Du har ikke tilgang til denne rollen", undefined);
            }
        }
        else {
            setCtx(new ContextMsg(2, [res.fields[0]]));
        }
    }));
    void (pr_1.catch((ex) => {
        toastServerError(setCtx, ex);
    }));
}

export function Headerbar() {
    let elems_13, elems_12, el_68;
    const patternInput = useCtx();
    const setCtx = patternInput[1];
    const ctx = patternInput[0];
    const screenSize = useFeliz_React__React_useResponsive_Static_Z434A9929();
    useEffectOnce(() => {
        if (equals(ctx.User.State, new UserState(1, []))) {
            fetchInitialNotifications((nots) => {
                setCtx(new ContextMsg(5, [nots]));
            }, setCtx);
        }
    });
    return createElement("div", createObj(ofArray([["style", {
        height: 60,
        display: "flex",
        flexDirection: "column",
    }], (elems_13 = [createElement("div", createObj(ofArray([["style", {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
    }], (elems_12 = toList(delay(() => {
        let matchValue, elems, el;
        return append((matchValue = screenSize, (matchValue.tag === 0) ? singleton(createElement("div", createObj(ofArray([["style", {
            minWidth: 44,
            minHeight: 44,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginLeft: 4,
        }], (elems = [(el = Hamburger, createElement(el, {
            size: "large",
            "aria-label": ctx.NavbarOpen ? "Lukk meny" : "Åpne meny",
            onClick: (ev) => {
                ev.stopPropagation();
                setCtx(new ContextMsg(3, [!ctx.NavbarOpen]));
            },
        }))], ["children", reactApi.Children.toArray(Array.from(elems))])])))) : ((matchValue.tag === 1) ? singleton(createElement("div", createObj(ofArray([["style", {
            minWidth: 44,
            minHeight: 44,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginLeft: 4,
        }], (elems = [(el = Hamburger, createElement(el, {
            size: "large",
            "aria-label": ctx.NavbarOpen ? "Lukk meny" : "Åpne meny",
            onClick: (ev) => {
                ev.stopPropagation();
                setCtx(new ContextMsg(3, [!ctx.NavbarOpen]));
            },
        }))], ["children", reactApi.Children.toArray(Array.from(elems))])])))) : ((matchValue.tag === 2) ? singleton(createElement("div", createObj(ofArray([["style", {
            minWidth: 44,
            minHeight: 44,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginLeft: 4,
        }], (elems = [(el = Hamburger, createElement(el, {
            size: "large",
            "aria-label": ctx.NavbarOpen ? "Lukk meny" : "Åpne meny",
            onClick: (ev) => {
                ev.stopPropagation();
                setCtx(new ContextMsg(3, [!ctx.NavbarOpen]));
            },
        }))], ["children", reactApi.Children.toArray(Array.from(elems))])])))) : singleton(createElement("div", {}))))), delay(() => {
            let elems_11, el_4, el_2, el_66, elems_10, el_12, el_10, elems_1, el_8, el_64, elems_9, elems_2, el_14, el_16, role, matchValue_3, region, matchValue_4, el_18, props_99, name_8, elemsToUse;
            return singleton(createElement("div", createObj(ofArray([["style", {
                display: "flex",
                gap: 10 + "px ",
            }], (elems_11 = [(el_4 = Button, createElement(el_4, {
                icon: (el_2 = DarkThemeRegular, createElement(el_2, {})),
                size: "large",
                appearance: "transparent",
                onClick: (_arg_1) => {
                    if (equals(ctx.ThemeType, new ThemeType(0, []))) {
                        setCtx(new ContextMsg(4, [new ThemeType(1, [])]));
                    }
                    else {
                        setCtx(new ContextMsg(4, [new ThemeType(0, [])]));
                    }
                },
            })), createElement(NotificationMenu, null), (el_66 = Menu, createElement(el_66, createObj(ofArray([["positioning", {
                position: "below",
                align: "end",
            }], (elems_10 = [(el_12 = MenuTrigger, createElement(el_12, {
                children: (el_10 = Button, createElement(el_10, createObj(ofArray([["size", "large"], ["appearance", "transparent"], (elems_1 = [(el_8 = Persona, createElement(el_8, createObj(toList(delay(() => {
                    let el_6;
                    return append(!(equals(screenSize, new ScreenSize(0, [])) ? true : equals(screenSize, new ScreenSize(1, []))) ? append(singleton(["primaryText", (el_6 = Subtitle2, createElement(el_6, {
                        children: abbreviateName(ctx.User.FirstName, ctx.User.LastName),
                        style: {
                            maxWidth: 150,
                            display: "inline-block",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                        },
                        wrap: false,
                    }))]), delay(() => {
                        let roleText;
                        const matchValue_1 = ctx.User.Role;
                        roleText = ((matchValue_1.tag === 2) ? "Kursholder" : ((matchValue_1.tag === 3) ? "Ekstern kursholder" : ((matchValue_1.tag === 0) ? "" : "Admin")));
                        let regionText;
                        const matchValue_2 = ctx.User.Workplace;
                        regionText = ((matchValue_2 != null) ? matchValue_2.Region.Name : "Ingen Region");
                        return singleton(["secondaryText", (roleText.length > 0) ? (`${regionText} · ${roleText}`) : regionText]);
                    })) : empty(), delay(() => append(singleton(["size", "extra-large"]), delay(() => singleton(["avatar", {
                        color: "colorful",
                        image: {
                            src: defaultArg(ctx.User.ThumbnailUrl, ""),
                        },
                    }])))));
                })))))], ["children", reactApi_1.Children.toArray(Array.from(elems_1))])])))),
            })), (el_64 = MenuPopover, createElement(el_64, createObj(ofArray([["style", {
                minWidth: 220,
            }], (elems_9 = [createElement("div", createObj(ofArray([["style", {
                display: "flex",
                flexDirection: "column",
                padding: ((((((8 + "px ") + 12) + "px ") + 6) + "px ") + 12) + "px",
            }], (elems_2 = [(el_14 = Body1Strong, createElement(el_14, {
                children: `${ctx.User.FirstName} ${ctx.User.LastName}`,
            })), (el_16 = Caption1, createElement(el_16, {
                style: {
                    color: tokens.colorNeutralForeground3,
                },
                children: (role = ((matchValue_3 = ctx.User.Role, (matchValue_3.tag === 2) ? "Kursholder" : ((matchValue_3.tag === 3) ? "Ekstern kursholder" : ((matchValue_3.tag === 0) ? "" : "Admin")))), (region = ((matchValue_4 = ctx.User.Workplace, (matchValue_4 != null) ? matchValue_4.Region.Name : "Ingen Region")), (role.length > 0) ? (`${region} · ${role}`) : region)),
            }))], ["children", reactApi.Children.toArray(Array.from(elems_2))])]))), (el_18 = MenuDivider, createElement(el_18, {})), (props_99 = toList(delay(() => {
                let el_24, elems_3, el_22, el_20;
                return append(singleton((el_24 = Link, createElement(el_24, createObj(ofArray([["style", {
                    textDecoration: "none",
                }], ["href", RouterModule_encodeParts(ofArray(["bruker", int32ToString(ctx.User.Id)]), 1)], (elems_3 = [(el_22 = MenuItem, createElement(el_22, {
                    icon: (el_20 = PersonRegular, createElement(el_20, {})),
                    children: "Brukerprofil",
                }))], ["children", reactApi_1.Children.toArray(Array.from(elems_3))])]))))), delay(() => {
                    let el_30, elems_4, el_28, el_26;
                    return append(singleton((el_30 = Link, createElement(el_30, createObj(ofArray([["style", {
                        textDecoration: "none",
                    }], ["href", RouterModule_encodeParts(ofArray(["bruker", int32ToString(ctx.User.Id), "fremdrift"]), 1)], (elems_4 = [(el_28 = MenuItem, createElement(el_28, {
                        icon: (el_26 = LayerDiagonalPersonRegular, createElement(el_26, {})),
                        children: "Fremdrift",
                    }))], ["children", reactApi_1.Children.toArray(Array.from(elems_4))])]))))), delay(() => {
                        let el_36, elems_5, el_34, el_32;
                        return append(singleton((el_36 = Link, createElement(el_36, createObj(ofArray([["style", {
                            textDecoration: "none",
                        }], ["href", RouterModule_encodeParts(ofArray(["bruker", int32ToString(ctx.User.Id), "historikk"]), 1)], (elems_5 = [(el_34 = MenuItem, createElement(el_34, {
                            icon: (el_32 = BookClockRegular, createElement(el_32, {})),
                            children: "Kurshistorikk",
                        }))], ["children", reactApi_1.Children.toArray(Array.from(elems_5))])]))))), delay(() => {
                            let el_38;
                            return append(equals(ctx.User.Role, new Role(1, [])) ? append(singleton((el_38 = MenuDivider, createElement(el_38, {}))), delay(() => {
                                let el_44, elems_6, el_42, el_40;
                                return singleton((el_44 = Link, createElement(el_44, createObj(ofArray([["style", {
                                    textDecoration: "none",
                                }], ["href", RouterModule_encodeParts(ofArray(["admin", "bruker", "godkjenn"]), 1)], (elems_6 = [(el_42 = MenuItem, createElement(el_42, {
                                    icon: (el_40 = PersonSettingsRegular, createElement(el_40, {})),
                                    children: "Administrer brukere",
                                }))], ["children", reactApi_1.Children.toArray(Array.from(elems_6))])])))));
                            })) : empty(), delay(() => {
                                let el_46;
                                const allowed = Role_AllowedViewAs_335EB78D(ctx.User.RealRole);
                                return append((length(allowed) > 1) ? append(singleton((el_46 = MenuDivider, createElement(el_46, {}))), delay(() => {
                                    let elems_7, el_48;
                                    return append(singleton(createElement("div", createObj(ofArray([["style", {
                                        padding: ((((((4 + "px ") + 12) + "px ") + 2) + "px ") + 12) + "px",
                                    }], (elems_7 = [(el_48 = Caption1, createElement(el_48, {
                                        style: {
                                            color: tokens.colorNeutralForeground3,
                                        },
                                        children: "Bytt rolle",
                                    }))], ["children", reactApi.Children.toArray(Array.from(elems_7))])])))), delay(() => map((role_1) => {
                                        let el_50, el_52;
                                        const el_54 = MenuItem;
                                        return createElement(el_54, {
                                            icon: equals(ctx.User.Role, role_1) ? ((el_50 = CheckmarkRegular, createElement(el_50, {}))) : ((el_52 = PersonRegular, createElement(el_52, {}))),
                                            children: Role__ToDescription(role_1),
                                            disabled: equals(ctx.User.Role, role_1),
                                            onClick: (_arg_2) => {
                                                switchActiveRole(equals(role_1, ctx.User.RealRole) ? undefined : role_1, setCtx);
                                            },
                                        });
                                    }, allowed)));
                                })) : empty(), delay(() => {
                                    let el_56;
                                    return append(singleton((el_56 = MenuDivider, createElement(el_56, {}))), delay(() => {
                                        let el_62, elems_8, el_60, el_58;
                                        return singleton((el_62 = Link, createElement(el_62, createObj(ofArray([["style", {
                                            textDecoration: "none",
                                        }], ["href", "/api/logout"], (elems_8 = [(el_60 = MenuItem, createElement(el_60, {
                                            icon: (el_58 = SignOutRegular, createElement(el_58, {})),
                                            children: "Logg ut",
                                        }))], ["children", reactApi_1.Children.toArray(Array.from(elems_8))])])))));
                                    }));
                                }));
                            }));
                        }));
                    }));
                }));
            })), (name_8 = MenuList, createElement(name_8, {
                children: reactApi.Children.toArray(Array.from(props_99)),
            })))], ["children", reactApi_1.Children.toArray(Array.from(elems_9))])]))))], (elemsToUse = ((length_1(elems_10) <= 2) ? elems_10 : take(2, elems_10)), ["children", reactApi_1.Children.toArray(elemsToUse)]))]))))], ["children", reactApi.Children.toArray(Array.from(elems_11))])]))));
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_12))])]))), (el_68 = Divider, createElement(el_68, {
        appearance: "subtle",
    }))], ["children", reactApi.Children.toArray(Array.from(elems_13))])])));
}

//# sourceMappingURL=Headerbar.jsx.map
